import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";

const CURRICULUM = [
  "Complete Frontend Development (HTML, CSS, JavaScript, Bootstrap & Tailwind)",
  "Complete Backend Development (Node.js, Express.js)",
  "Complete Database — SQL & MongoDB",
  "Complete MERN Stack (MongoDB, Express, React, Node)",
  "Real Life and Industry Grade Projects",
];

const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];

const JavaFullstack = () => (
  <CourseDetailTemplate
    title="Java Full Stack Development Course"
    description="Develop dynamic web applications with Java. Master Java programming, Angular for responsive front-end development, and Spring Boot for robust back-end systems — culminating in a comprehensive skillset to build, integrate, and deploy cloud-ready web applications."
    curriculum={CURRICULUM}
    structure={STRUCTURE}
    tags={["Java", "Spring Boot", "Angular", "SQL", "MongoDB"]}
    programName="Java Full Stack Development Course"
  />
);

export default JavaFullstack;
